import { Button, DropDownSelect, Form, TextInput, showToast } from "@prishapolicy/shared/ui"
import { useState } from "react"
import ArrowRight from './arrowRight.png'
import Image from 'next/image'
import { trpcNoAuth } from '@prishapolicy/shared/trpc';
import * as Yup from "yup";
import { getTabs } from "./helper";

export const singleEntryValidationMapping = {
    "basic-info": {
        fullName: Yup.string()
            .required("Full name is required"),

        phoneNumber: Yup.string()
            .required("Phone number is required")
            .matches(/^[0-9]+$/, "Phone number must be digits only")
            .min(10, "Phone number must be at least 10 digits"),


        industry: Yup.string().required("Industry is required")
    },
    "additional-info": {
        companyName: Yup.string()
            .required("Company name is required")
            .min(2, "Company name must be at least 2 characters"),

        tenderName: Yup.string().required("Tender name is required"),

        bondAmount: Yup.number()
            .required("Bond amount required")
            .min(0, "Bond amount must be a positive number")
    }
}


const industries = [
    "Auto Components",
    "Automobiles",
    "Aviation",
    "Ayush",
    "Banking",
    "Biotechnology",
    "Cement",
    "Chemicals",
    "Consumer Durables",
    "Defence Manufacturing",
    "E-Commerce",
    "Education and Training",
    "Electric Vehicle",
    "Electronics System Design & Manufacturing",
    "Engineering and Capital Goods",
    "Financial Services",
    "FMCG",
    "Food Processing",
    "Gems and Jewellery",
    "Media and Entertainment",
    "Medical Devices",
    "Metals and Mining",
    "MSME",
    "Oil and Gas",
    "Paper & Packaging",
    "Pharmaceuticals",
    "Ports",
    "Power",
    "Railways",
    "Real Estate",
    "Renewable Energy",
    "Retail",
    "Roads",
    "Science and Technology",
    "Services",
    "Steel",
    "Telecommunications",
    "Textiles",
    "Tourism and Hospitality"
]

export const SuretyBondForm = () => {
    const [stepForm, setStepForm] = useState<"basic-info" | "additional-info">("basic-info")

    const { isLastTab } = getTabs(stepForm);


    const createSuretyBondLeadMutation = trpcNoAuth['lead-management']['lead']['create-lead-for-surety-bond'].useMutation();

    return (
        <div className='bg-white rounded-[10px] h-full  z-50 shadow-xl'>
            <div className="p-6 flex flex-col gap-6">
                <div className="flex gap-[10px] ">
                    <h1 className={`text-body-3 cursor-pointer ${stepForm === "basic-info" ? "font-bold" : "font-normal"} `}
                        onClick={() => setStepForm("basic-info")}
                    >Basic Info</h1>
                    <Image src={ArrowRight} alt={"arrow-right"} />
                    <h1 className={`text-body-3 ${stepForm === "additional-info" ? "font-bold" : "font-normal"}`}>Additional Info</h1>
                </div>
                <div>
                    <h1 className="font-bold text-title-6 ">{stepForm === "basic-info" ? "Let’s start with your basic Info" : "Just few additional details"}</h1>
                </div>
                <Form initialValues={{
                    fullName: "",
                    phoneNumber: "",
                    email: "",
                    industry: "",
                    companyName: "",
                    annualTurnover: "",
                    tenderName: "",
                    bondAmount: ""
                }}
                    validationSchema={Yup.object().shape({ ...singleEntryValidationMapping[stepForm] })}
                    onSubmit={async (values) => {
                        if (!isLastTab) {
                            setStepForm("additional-info")
                        } else {
                            const data = await createSuretyBondLeadMutation.mutateAsync({
                                fullName: values.fullName,
                                phoneNumber: values.phoneNumber,
                                email: values.email,
                                industry: values.industry,
                                companyName: values.companyName,
                                annualTurnover: values.annualTurnover,
                                tenderName: values.tenderName,
                                bondAmount: values.bondAmount
                            });
                            console.log(data,"data")
                            showToast({
                                title: 'Successfully Submitted Details',
                                variant: 'success',
                            });
                            console.log(values, "values")
                        }
                    }}>

                    {
                        stepForm === "basic-info" ?
                            <div className="flex flex-col gap-4">
                                <TextInput name="fullName" label="Full Name" />
                                <TextInput name="phoneNumber" label="Phone Number" />
                                <TextInput name="email" label="Email" />
                                <DropDownSelect
                                    name="industry"
                                    options={[
                                        {
                                            options: industries.map((industry) => ({
                                                value: industry
                                            }))
                                        },
                                    ]}
                                />
                                <Button
                                    text="Continue"
                                    theme="primary"
                                    variant="primary"
                                    rightIcon="arrowRight"
                                    type="submit" />
                            </div>
                            :
                            <div className="flex flex-col gap-4">
                                <TextInput name="companyName" label="Company Name" />
                                <TextInput name="annualTurnover" label="Annual Turnover of the company (Optional)" />
                                <TextInput name="tenderName" label="Name of the Tender and the Issuing Authority" />
                                <TextInput name="bondAmount" label="Bond Amount (In INR)" />
                                <Button
                                    text="Submit Details"
                                    theme="primary"
                                    variant="primary"
                                    type="submit"
                                />
                            </div>
                    }

                </Form>
            </div>
        </div>
    )
}